<mdb-navbar SideClass="navbar navbar-dark navbar-expand-md custom-navbar" [containerInside]="false">
  <logo>
    <label [hidden]="showBackButton()" class="navbar-brand mb-0">
      <chapps-apps-list [applicationName]="Localization.ApplicationName"></chapps-apps-list>
    </label>
    <h5 *ngIf="showBackButton()" class="ml-2 mb-0 d-flex align-items-center" appTextColor="secondary"
      (click)="goBack()">
      <i class="fa fa-lg fa-angle-left mr-2"></i>
      <span>{{Localization.Back | translate}}</span>
    </h5>
  </logo>
  <links>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item rounded" [appBg]="(isIssuesButtonActive) ? 'secondary' : 'none'" brightness="normal">
        <a routerLink="/issues" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-exclamation-circle mr-1"></i>
          <span>{{Localization.Issues | translate}}</span>
        </a>
      </li>
      <li class="nav-item rounded" [appBg]="(isActionsButtonActive) ? 'secondary' : 'none'" brightness="normal">
        <a
          routerLink="/jobs/list"
          routerLinkActive="active"
          class="nav-link waves-light"
          mdbWavesEffect
        >
          <svg-icon src="assets/images/generic/toolbox.svg" [className]="'mr-1'" l></svg-icon>
          {{ Localization.Jobs | translate }}
        </a>
      </li>
      <li class="nav-item rounded">
        <a [href]="zendeskUrl" target="_blank" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-question-circle mr-1"></i>
          <span>{{Localization.Help | translate}}</span>
        </a>
      </li>
      <li class="nav-item dropdown" dropdown #dropdown1="bs-dropdown"
        [ngClass]="{ 'active rounded': areSettingsActive }">
        <a dropdownToggle mdbRippleRadius type="button" class="nav-link dropdown-toggle waves-light pl-3 pr-3"
          mdbRippleRadius (click)="dropdown2.hide()">
          <i class="fa fa-cog mr-1"></i>
          <span class="d-xl-none">{{ Localization.Settings | translate }}</span>
          <span class="caret"></span></a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-ins dropdown-menu-right" role="menu">
          <a routerLink="/contacts" class="dropdown-item waves-light" [class.active]="isContactsButtonActive"
            mdbRippleRadius (click)="dropdown1.hide()">
            <i class="fa fa-user mr-1"></i>
            <span>{{Localization.Contacts | translate}}</span>
          </a>
          <a routerLink="/intervention-teams/list" class="dropdown-item waves-light"
            [class.active]="isInterventionTeamsButtonActive" mdbRippleRadius (click)="dropdown1.hide()">
            <i class="fa fa-users mr-1"></i>
            <span>{{Localization.InterventionTeams | translate}}</span>
          </a>
          <a routerLink="/logins" class="dropdown-item waves-light" [class.active]="isLoginsButtonActive"
            mdbRippleRadius (click)="dropdown1.hide()">
            <i class="fa fa-sign-in mr-1"></i>
            <span>{{ Localization.Logins | translate }}</span>
          </a>
        </div>
      </li>
      <li class="nav-item dropdown ml-2" dropdown #dropdown2="bs-dropdown">
        <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect
          (click)="dropdown1.hide()">
          <i class="fa fa-user mr-1"></i>
          <span class="caret"></span>
        </a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-ins dropdown-menu-right" role="menu">
          <h6 class="dropdown-header">
            <div class="mb-2"><strong>{{userName}}</strong></div>
            <div><a routerLink="/logins" class="pl-0">{{userEmail}}</a></div>
          </h6>
          <div class="divider dropdown-divider"></div>
          <a class="dropdown-item waves-light" mdbRippleRadius (click)="logout()">
            <i class="fa fa-sign-out mr-1"></i>
            <span>{{ Localization.Logout | translate}}</span>
          </a>
        </div>
      </li>
    </ul>
  </links>
</mdb-navbar>
